module.exports = {
      id: "vikatan-play-logo-red-usage",
      viewBox: "0 0 536.066 789.439",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#vikatan-play-logo-red",
      toString: function () {
        return this.url;
      }
    }